import React from "react";
import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

import { spacing } from "@mui/system";

import {
  Box as MuiBox,
  Drawer as MuiDrawer,
  ListItemButton,
} from "@mui/material";

import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const Sidebar = ({
  items,
  preventNavigation,
  setPreventNavigation,
  showFooter = true,
  ...rest
}) => {
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  return (
    <Drawer variant="permanent" {...rest}>
      <Brand
        component={NavLink}
        to={
          authData?.type === "customer_user"
            ? "/dashboard/stats"
            : "/dashboard/tasks"
        }
      >
        <Box
          component="img"
          alt="AlphaPlus"
          src="/static/img/avatars/ap-logo-bw-inverted.png"
          style={{
            padding: "8px",
            marginLeft: "-16px",
            height: "64px",
            width: "auto",
          }}
        />
      </Brand>
      <SidebarNav
        items={items}
        preventNavigation={preventNavigation}
        setPreventNavigation={setPreventNavigation}
      />
      {!!showFooter && <Footer />}
    </Drawer>
  );
};

export default Sidebar;
